// app/Providers.tsx
import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BffError } from '@/lib/http/bffClient';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Auth failures should immediately surface (and the BFF client will redirect to /login).
        if (error instanceof BffError && error.status === 401) return false;
        // Circuit-breaker open — don't hammer, the BFF is actively rejecting.
        if (error?.errorCode === 'circuit_open' || error?.errorCode === 'service_unavailable') return false;
        // 503 / 502 — limited retries with longer backoff (handled by retryDelay)
        if (error?.status === 503 || error?.status === 502) return failureCount < 2;
        return failureCount < 3;
      },
      retryDelay: (attempt, error: any) => {
        // Exponential backoff: 1s → 2s → 4s, but 503/502 start at 5s
        if (error?.status === 503 || error?.status === 502) {
          return Math.min(5_000 * (2 ** attempt), 30_000);
        }
        return Math.min(1_000 * (2 ** attempt), 10_000);
      },
    },
  },
});

export default function Providers({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={qc}>{children}</QueryClientProvider>;
}